import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReceipt, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { FINANCE_NAV } from './nav';

const TaxReporting: React.FC = () => {
    const { api } = useInternalApi();
    const [rows, setRows] = useState<{ month: string; total: number }[]>([]);
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => { document.title = 'Tax & Regulatory Reporting - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('admin-dashboard/finance/tax-reporting/').then(res => {
            if (res.data?.status === 'success') {
                setRows(res.data.data.revenue_by_month || []);
                setNote(res.data.data.note || '');
            }
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <InternalShell activeDashboard="finance_center" subNav={FINANCE_NAV}>
            <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faReceipt} className="me-2 text-primary" />Tax & Regulatory Reporting</h2>
            <p className="text-muted mb-4">Gross revenue by month — a preparation input, not a computed tax liability</p>

            <div className="alert alert-info"><FontAwesomeIcon icon={faInfoCircle} className="me-2" />{note}</div>

            {loading ? (
                <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
            ) : (
                <div className="card border-0 shadow-sm">
                    <div className="card-body p-0">
                        {rows.length === 0 ? (
                            <div className="text-center py-5 text-muted">No revenue recorded in the last 12 months.</div>
                        ) : (
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-light"><tr><th>Month</th><th>Gross Revenue (KES)</th></tr></thead>
                                <tbody>
                                    {rows.map(r => (
                                        <tr key={r.month}><td>{r.month}</td><td>{r.total.toLocaleString()}</td></tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            )}
        </InternalShell>
    );
};

export default TaxReporting;
